export default "__VITE_ASSET__C8SA2r5p__"